import React from "react";
import { INK2 } from "./chatTheme";

/** „… schreibt"-Zeile; aggregiert mehrere Tippende. Leer = nichts rendern. */
export const TypingIndicator: React.FC<{ names: string[] }> = ({ names }) => {
  if (!names.length) return null;
  let text: string;
  if (names.length === 1) text = `${names[0]} schreibt …`;
  else if (names.length === 2) text = `${names[0]} und ${names[1]} schreiben …`;
  else text = "Mehrere schreiben …";
  return (
    <div
      aria-live="polite"
      style={{ minHeight: 18, padding: "2px 6px", fontSize: 12, fontStyle: "italic", color: INK2 }}
    >
      {text}
    </div>
  );
};

export default TypingIndicator;
